import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import IncentiveService from "services/prospect/incentiveService";
import { notification } from "antd";
export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  incentiveData: [],
  error: null,
  saveLoading: false,
  saveSuccess: false,
  saveError: null,
};

export const getIncentiveAdd = createAsyncThunk(
  "incentive/getIncentiveAdd",
  async (prospectId, { rejectWithValue }) => {
    try {
      const response = await IncentiveService.getIncentiveAdd(prospectId);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const saveIncentiveData = createAsyncThunk(
  "incentive/saveIncentiveData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await IncentiveService.saveIncentive(payload);
       if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to save incentive data!");
    }
  }
);

export const IncentiveSlice = createSlice({
  name: "incentiveKKB",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    clearIncentiveData: (state) => {
      state.incentiveData = null;
      state.error = null;
    },
    resetSaveState: (state) => {
      state.saveLoading = false;
      state.saveSuccess = false;
      state.saveError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getIncentiveAdd.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getIncentiveAdd.fulfilled, (state, action) => {
        console.log("incentiveData1111", action.payload);
        state.loading = false;
        state.incentiveData = action.payload?.data;
        state.showMessage = false;
      })
      .addCase(getIncentiveAdd.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.message = action.payload;
        state.showMessage = true;
      })
      .addCase(saveIncentiveData.pending, (state) => {
        state.saveLoading = true;
        state.saveSuccess = false;
        state.saveError = null;
      })
      .addCase(saveIncentiveData.fulfilled, (state, action) => {
        state.saveLoading = false;
        state.saveSuccess = true;
        state.saveError = null;
        state.message = "Data insentif berhasil disimpan!";
        state.showMessage = true;
      })
      .addCase(saveIncentiveData.rejected, (state, action) => {
        state.saveLoading = false;
        state.saveSuccess = false;
        state.saveError = action.payload;
        state.message = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  showNotification,
  hideNotification,
  showLoading,
  clearIncentiveData,
  resetSaveState,
} = IncentiveSlice.actions;

export default IncentiveSlice.reducer;
